import React from "react";
import { FormProps } from "./Form.types";
import {
  StyledWrapper,
  StyledInnerWrapper,
  StyledInput,
  StyledInputsWrapper,
  AfterSendError,
} from "./Form.styles";
import { useTranslation } from "react-i18next";
import { Button } from "@components/atoms/Button";
import { useForm } from "./Form.hooks";
import { EMAIL_PATTERN } from "@constants";

const Form: React.FC<FormProps> = (props) => {
  const { t } = useTranslation("contact");
  const { handleSubmit, sendError, errors, register, isLoading } = useForm();

  return (
    <StyledWrapper>
      <StyledInnerWrapper onSubmit={handleSubmit} $block={sendError}>
        <StyledInputsWrapper>
          <StyledInput
            placeholder={t("first-name")}
            darker
            required
            {...register("name", {
              required: true,
            })}
            error={
              errors?.name?.type === "required"
                ? t("missing-first-name")
                : undefined
            }
          />
          <StyledInput
            placeholder={t("email")}
            darker
            error={
              errors?.email?.type === "pattern"
                ? t("bad-email")
                : errors?.email?.type === "required"
                ? t("missing-email")
                : undefined
            }
            {...register("email", { pattern: EMAIL_PATTERN, required: true })}
          />
        </StyledInputsWrapper>
        <Button disabled={sendError} isLoading={isLoading}>
          {t("sign-up")}
        </Button>
      </StyledInnerWrapper>
      {sendError && <AfterSendError>{t("error")}</AfterSendError>}
    </StyledWrapper>
  );
};

export default Form;
